import { Chip } from '@mui/material';

function Badge({ children, tone = 'neutral' }) {
  const colorMap = { neutral: 'default', success: 'success', info: 'info', danger: 'error' };
  return <Chip label={children} size="small" color={colorMap[tone] || 'default'} variant={tone === 'neutral' ? 'outlined' : 'filled'} />;
}

export default Badge;
